import { BLIState } from '../states';

export const complete = (state: BLIState): boolean => {
  return state.answers.id !== undefined && state.answers.id !== null;
};
